import { hollowPie, solidPie, radiusPie, annularPie } from './components';
export default {
  name: 'pie',
  components: {
    hollowPie,
    solidPie,
    radiusPie,
    annularPie
  },
  data() {
    return {};
  }
};